import { apiClient } from "./client";

const GetAll = () => {
  return apiClient
    .get("/Plan");
}

const GetByKey = (id) => {
  return apiClient
    .get("/Plan/GetById", {
      params: {
        'key': id
      }
    });
}

const PlanDropDown = () => {
  return apiClient
    .get("/Plan/PlanDropDown");
}

const GetForUser = () => {
  return apiClient
    .get("/Plan/GetForUser");
}
const GetPlanInfoStructureByPlanId = (planId) => {
  return apiClient
    .get("/Plan/GetPlanInfoStructureByPlanId", {
      params: {
        'PlanId': planId
      }
    });
}

const GetHotelplanReserved = (hotelId, reserveId) => {
  return apiClient
    .get("/Plan/GetHotelplanReserved", {
      params: {
        'hotelId': hotelId,
        'reserveId': reserveId
      }
    });
}

const SoftDelete = (id) => {
  return apiClient
    .delete("/Plan/SoftDelete", {
      params: {
        'Id': id,
        'delete': true
      }
    });
}

const Add = (data) => {
  return apiClient.post('/Plan', {
    'planCode': data.planCode,
    'hotelStructureId': data.hotelStructureId,
    'planRoomId': data.planRoomId,
  }
  )
}

const AddRoomToPlan = (data) => {
  return apiClient.put('/Plan/AddRoomToPlan', null,
    {
      params: {
        'RoomId': data.RoomId,
        'PlanCode': data.PlanCode,
      }
    }
  )
}

const RemoveRoomToPlan = (roomId, planCode) => {
  return apiClient.put('/Plan/RemoveRoomToPlan', null,
    {
      params: {
        'RoomId': roomId,
        'PlanCode': planCode,
      }
    }
  )
}

const planApi = { Add, GetAll, GetByKey, PlanDropDown, GetForUser, GetPlanInfoStructureByPlanId, GetHotelplanReserved, SoftDelete, AddRoomToPlan, RemoveRoomToPlan }
export default planApi;